export default __webpack_public_path__ + "static/media/InvertedCommas.7ed9cd9b.svg";